import React, { Component } from 'react';
import PT from 'prop-types';
import cIf from 'classnames';
import { MDCRipple } from '@material/ripple';

export class Button extends Component {
    constructor(props) {
        super(props);
        this.mdButtonRef = React.createRef();
    }

    componentDidMount() {
        if (this.props.useRippleEffect)
            // Note: we need to instanciate MDCRipple here, since it's required by Material Design
            //eslint-disable-next-line sonarjs/constructor-for-side-effects
            new MDCRipple(this.mdButtonRef.current);
    }

    render() {
        return (
            <button 
                id={this.props.id}
                onClick={this.props.onClick || this.props.onButtonClicked}
                ref={this.mdButtonRef}
                className={cIf(["mdc-button", this.props.customClasses], {
                    "mdc-button--unelevated": this.props.hasBackground,
                    "larger-rese-button": this.props.isLarge, "rese-button": (!this.props.isLarge && !this.props.hasOnlyIconButton),
                    "smaller-rese-button": this.props.isSmall,
                    "only-icon-rese-button": this.props.hasOnlyIconButton,
                    "smaller-font-size": this.props.useSmallerFontSize,
                    "horizontal-space left": this.props.useLeftMargin,
                    "horizontal-space right": this.props.useRightMargin,
                    "no-letter-spacing": !this.props.addLetterSpacing,
                    "simple-rese-button": !this.props.hasBackground,
                    "simple-rese-button--white": this.props.isWhiteText
                })}
            >
                <div className="mdc-button__ripple" />
                {this.props.children}
            </button>
        );
    }
}
Button.propTypes = {
    type: PT.string,
    icon: PT.string,
    onClick: PT.func,
    /** @deprecated Use the standard onClick instead */
    onButtonClicked: PT.func,
    buttonRef: PT.object,
    isLarge: PT.bool,
    isSmall: PT.bool,
    hasOnlyIconButton: PT.bool,
    useSmallerFontSize: PT.bool,
    useLeftMargin: PT.bool,
    useRightMargin: PT.bool,
    id: PT.string,
    customClasses: PT.array,
    useRippleEffect: PT.bool,
    addLetterSpacing: PT.bool,
    hasBackground: PT.bool,
    isWhiteText: PT.bool
};
Button.defaultProps = {
    type: 'button',
    isLarge: false,
    isSmall: false,
    hasOnlyIconButton: false,
    useSmallerFontSize: false,
    useLeftMargin: false,
    useRightMargin: false,
    useRippleEffect: true,
    addLetterSpacing: true,
    hasBackground: true,
    isWhiteText: false
};
